import React, { useState } from "react";
import "./StickerBox.css"; // Make sure to create and import this CSS file

import { ReactComponent as PlusSymbol } from "assets/icons/plus-symbol.svg";
import { ReactComponent as CloseSymbol } from "assets/icons/close-symbol.svg";

import Sticker from "components/Sticker/Sticker";
// Assuming initialStickers is passed as a prop
const StickerBox = ({ initialStickers, onStickerSelect }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  const handleStickerSelect = (sticker) => {
    onStickerSelect(sticker);
    closeModal();
  };

  return (
    <div className="sticker-box">
      <a onClick={openModal} className="add-sticker-btn data-gtm-addSticker">
        <span>
          <PlusSymbol />
        </span>
        Add custom stickers
      </a>
      {modalIsOpen ? (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content mobile-scroll" onClick={(e) => e.stopPropagation()}>
            <button onClick={closeModal} className="close-button">
              <CloseSymbol />
            </button>
            <div className="content">
              <h2>Add custom stickers</h2>
              <p>
                Select a sticker to add to your design. Position as desired.
              </p>
            </div>
            <div className="sticker-modal">
              <div className="sticker-grid">
                {initialStickers.map((sticker) => (
                  <Sticker
                    key={sticker.id}
                    id={sticker.id}
                    src={sticker.src}
                    onClick={() => handleStickerSelect(sticker.src)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default StickerBox;
